<script lang="ts" setup>
// Soft-delete confirmation. Matches the inline modal pattern used elsewhere in the project area
// (see ProjectForm.vue) rather than introducing a new abstraction. Emits confirm/cancel; the
// parent owns the mutation and visibility so it can keep the modal open / show errors as needed.
defineProps<{
  show: boolean;
  projectName: string;
  pending?: boolean;
}>();

const emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();
</script>

<template>
  <template v-if="show">
    <div
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      @click.self="emit('cancel')"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title text-danger">
              <i class="bi bi-exclamation-triangle me-2"></i>Delete Project
            </h2>
            <button type="button" class="btn-close" :disabled="pending" @click="emit('cancel')"></button>
          </div>
          <div class="modal-body">
            <p>Delete <strong>{{ projectName }}</strong>?</p>
            <p class="text-muted mb-0">
              Its name becomes reusable immediately. You can restore it later from
              Projects &rsaquo; Recycle Bin.
            </p>
          </div>
          <div class="modal-footer">
            <button class="bb-btn-cancel" :disabled="pending" @click="emit('cancel')">Cancel</button>
            <button class="btn btn-danger" :disabled="pending" data-cy="confirm-delete" @click="emit('confirm')">
              <span v-if="pending" class="spinner-border spinner-border-sm me-1" role="status"></span>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" @click="emit('cancel')"></div>
  </template>
</template>
